import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Users } from "lucide-react";
import { cn } from "../../../utils";
import { Badge } from "../../base/badge/badge";
import { Item, ItemContent, ItemDescription, ItemMedia, ItemTitle } from "../../base/item/item";
import { appendDeletedSuffix, DELETED_ENTITY_CLASS, isAssigneeDeleted } from "../../../utils/deleted-entity-utils";
export const OrgFunctionCard = /*#__PURE__*/ React.forwardRef(({ orgFunction, variant = "name-only", itemVariant = "default", size = "default", className, titleSlot, descriptionSlot, rightSlot, mediaSlot }, ref)=>{
    const { t } = useTranslation();
    const isDeleted = isAssigneeDeleted(orgFunction);
    let secondaryText = null;
    if (variant === "with-email") {
        secondaryText = orgFunction.email;
    } else if (variant === "with-description") {
        secondaryText = orgFunction.description;
    }
    const showDescription = descriptionSlot ?? secondaryText;
    const departmentAbbreviation = orgFunction.department && typeof orgFunction.department === "object" ? orgFunction.department.abbreviation : undefined;
    return /*#__PURE__*/ _jsxs(Item, {
        ref: ref,
        variant: itemVariant,
        size: size,
        className: cn(className, isDeleted && DELETED_ENTITY_CLASS),
        children: [
            /*#__PURE__*/ _jsx(ItemMedia, {
                variant: "icon",
                children: mediaSlot ?? /*#__PURE__*/ _jsx(Users, {
                    className: "h-4 w-4"
                })
            }),
            /*#__PURE__*/ _jsxs(ItemContent, {
                children: [
                    /*#__PURE__*/ _jsx(ItemTitle, {
                        children: titleSlot ?? appendDeletedSuffix(orgFunction.name, isDeleted, t)
                    }),
                    showDescription && /*#__PURE__*/ _jsx(ItemDescription, {
                        children: showDescription
                    })
                ]
            }),
            rightSlot ? rightSlot : departmentAbbreviation && /*#__PURE__*/ _jsx(Badge, {
                variant: "outline",
                className: "self-center",
                children: departmentAbbreviation
            })
        ]
    });
});
OrgFunctionCard.displayName = "OrgFunctionCard";

//# sourceMappingURL=org-function-card.js.map